<span class="fa-layers samweb-fa-layers">
   <fa-icon [icon]="menuItemIcon"></fa-icon>
   <fa-icon
      class="fa-stack {{ menuStackedItemClass }}"
      [icon]="menuStackedItemIcon"
      *ngIf="menuStackedItemIcon !== null"
   ></fa-icon>
</span>
<span class="item-label">{{ menuItemTranslationKey | translate }}</span>
